/**
 * Equipment 模块常量定义（自动生成）
 * 
 * ⚠️ 此文件由 api:export-types 命令自动生成
 * ⚠️ 请勿手动编辑！如需修改，请修改后端代码后重新生成
 * 
 * 包含：
 * - 枚举标签映射（中文）
 * - 权限常量定义
 * 
 * 验证规则请查看 validations.ts
 * 
 * @generated 2025-11-02T18:26:32.722581Z
 * @generator api:export-types v1.0.0
 */

import { EquipmentSTATUS, EquipmentInspectionRecordTYPE, EquipmentInspectionRecordRESULT, EquipmentMaintenanceLogTYPE, EquipmentMaintenanceLogRESULT, EquipmentMaintenancePlanTYPE, EquipmentMaintenancePlanCYCLE, EquipmentMaintenanceTaskSTATUS, EquipmentRepairSTATUS, EquipmentRepairURGENCY, EquipmentRepairFAULT } from './enums'

// ==================== 枚举标签映射 ====================

/**
 * Equipment状态 标签映射
 */
export const EQUIPMENT_S_T_A_T_U_S_LABELS = {
  [EquipmentSTATUS.IDLE]: 'IDLE',
  [EquipmentSTATUS.RUNNING]: 'RUNNING',
  [EquipmentSTATUS.MAINTENANCE]: 'MAINTENANCE',
  [EquipmentSTATUS.SERVICING]: 'SERVICING',
  [EquipmentSTATUS.DISABLED]: 'DISABLED',
} as const

/**
 * EquipmentInspectionRecord类型 标签映射
 */
export const EQUIPMENT_INSPECTION_RECORD_T_Y_P_E_LABELS = {
  [EquipmentInspectionRecordTYPE.DAILY]: 'DAILY',
  [EquipmentInspectionRecordTYPE.WEEKLY]: 'WEEKLY',
  [EquipmentInspectionRecordTYPE.MONTHLY]: 'MONTHLY',
} as const

/**
 * EquipmentInspectionRecordRESULT 标签映射
 */
export const EQUIPMENT_INSPECTION_RECORD_R_E_S_U_L_T_LABELS = {
  [EquipmentInspectionRecordRESULT.PASS]: 'PASS',
  [EquipmentInspectionRecordRESULT.FAIL]: 'FAIL',
} as const

/**
 * EquipmentMaintenanceLog类型 标签映射
 */
export const EQUIPMENT_MAINTENANCE_LOG_T_Y_P_E_LABELS = {
  [EquipmentMaintenanceLogTYPE.ROUTINE]: 'ROUTINE',
  [EquipmentMaintenanceLogTYPE.REPAIR]: 'REPAIR',
  [EquipmentMaintenanceLogTYPE.OVERHAUL]: 'OVERHAUL',
} as const

/**
 * EquipmentMaintenanceLogRESULT 标签映射
 */
export const EQUIPMENT_MAINTENANCE_LOG_R_E_S_U_L_T_LABELS = {
  [EquipmentMaintenanceLogRESULT.COMPLETED]: 'COMPLETED',
  [EquipmentMaintenanceLogRESULT.PENDING]: 'PENDING',
} as const

/**
 * EquipmentMaintenancePlan类型 标签映射
 */
export const EQUIPMENT_MAINTENANCE_PLAN_T_Y_P_E_LABELS = {
  [EquipmentMaintenancePlanTYPE.DAILY]: 'DAILY',
  [EquipmentMaintenancePlanTYPE.WEEKLY]: 'WEEKLY',
  [EquipmentMaintenancePlanTYPE.MONTHLY]: 'MONTHLY',
  [EquipmentMaintenancePlanTYPE.QUARTERLY]: 'QUARTERLY',
  [EquipmentMaintenancePlanTYPE.YEARLY]: 'YEARLY',
} as const

/**
 * EquipmentMaintenancePlanCYCLE 标签映射
 */
export const EQUIPMENT_MAINTENANCE_PLAN_C_Y_C_L_E_LABELS = {
  [EquipmentMaintenancePlanCYCLE.DAY]: 'DAY',
  [EquipmentMaintenancePlanCYCLE.WEEK]: 'WEEK',
  [EquipmentMaintenancePlanCYCLE.MONTH]: 'MONTH',
  [EquipmentMaintenancePlanCYCLE.YEAR]: 'YEAR',
} as const

/**
 * EquipmentMaintenanceTask状态 标签映射
 */
export const EQUIPMENT_MAINTENANCE_TASK_S_T_A_T_U_S_LABELS = {
  [EquipmentMaintenanceTaskSTATUS.PENDING]: 'PENDING',
  [EquipmentMaintenanceTaskSTATUS.IN_PROGRESS]: 'IN_PROGRESS',
  [EquipmentMaintenanceTaskSTATUS.COMPLETED]: 'COMPLETED',
  [EquipmentMaintenanceTaskSTATUS.OVERDUE]: 'OVERDUE',
  [EquipmentMaintenanceTaskSTATUS.CANCELLED]: 'CANCELLED',
} as const

/**
 * EquipmentRepair状态 标签映射
 */
export const EQUIPMENT_REPAIR_S_T_A_T_U_S_LABELS = {
  [EquipmentRepairSTATUS.PENDING]: 'PENDING',
  [EquipmentRepairSTATUS.ASSIGNED]: 'ASSIGNED',
  [EquipmentRepairSTATUS.IN_PROGRESS]: 'IN_PROGRESS',
  [EquipmentRepairSTATUS.COMPLETED]: 'COMPLETED',
  [EquipmentRepairSTATUS.CANCELLED]: 'CANCELLED',
} as const

/**
 * EquipmentRepairURGENCY 标签映射
 */
export const EQUIPMENT_REPAIR_U_R_G_E_N_C_Y_LABELS = {
  [EquipmentRepairURGENCY.NORMAL]: 'NORMAL',
  [EquipmentRepairURGENCY.URGENT]: 'URGENT',
  [EquipmentRepairURGENCY.CRITICAL]: 'CRITICAL',
} as const

/**
 * EquipmentRepairFAULT 标签映射
 */
export const EQUIPMENT_REPAIR_F_A_U_L_T_LABELS = {
  [EquipmentRepairFAULT.TYPE_MECHANICAL]: 'TYPE_MECHANICAL',
  [EquipmentRepairFAULT.TYPE_ELECTRICAL]: 'TYPE_ELECTRICAL',
  [EquipmentRepairFAULT.TYPE_HYDRAULIC]: 'TYPE_HYDRAULIC',
  [EquipmentRepairFAULT.TYPE_OTHER]: 'TYPE_OTHER',
} as const

